import React from 'react'
import BasicLayout from '../../layouts/BasicLayout'
import SubTitle from '../../components/user/SubTitle'
import AboutContent from '../../components/user/AboutContent'
import MetaTag from '../../components/user/MetaTag'

function AboutPage() {
    return (
        <BasicLayout>
            <div className="max-w-3xl mx-auto px-4 py-8">
                <MetaTag
                    title="주거 인테리어 리모델링 전문 스튜디오 | 더룸"
                    description="더룸(THEROOM)은 주거 인테리어 리모델링에 특화된 스튜디오입니다. 회사 소개, 위치, 연락처를 한눈에 확인하실 수 있습니다."
                    imgsrc="https://www.theroom.co.kr/assets/logos/og-image.png"
                    url="https://www.theroom.co.kr/about"
                />
                <SubTitle content={"ABOUT"} />
                <AboutContent />
            </div>
        </BasicLayout>
    )
}

export default AboutPage